<app-terms-view [allTermData]="allTermData$ | async"></app-terms-view>
